<template>
  <div class="wrapper">
    <parallax class="page-header header-filter" :style="headerStyle">
      <div class="md-layout">
        <div class="md-layout-item">
          <div class="image-wrapper">
            <img :src="leaf4" alt="leaf4" class="leaf4" v-show="leafShow" />
            <img :src="leaf3" alt="leaf3" class="leaf3" v-show="leafShow" />
            <img :src="leaf2" alt="leaf2" class="leaf2" v-show="leafShow" />
            <img :src="leaf1" alt="leaf1" class="leaf1" v-show="leafShow" />
            <div class="brand">
              <h1>Newmanizer</h1>
              <h3>A Badass Newman UI.</h3>
            </div>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section section-basic" v-show="!showSpinner">
        <div class="container-vue">
          <div class="title">
            <h1>&#128640; Get started !</h1>
          </div>
          <h2>1. Input your API key</h2>
          <div
            class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
          >
            <md-field>
              <label>API Key</label>
              <md-input
                v-model="apiKey"
                type="text"
                name="apiKey"
                autocomplete
              ></md-input>
            </md-field>
            <md-button
              class="md-primary"
              v-if="workspaces.length === 0"
              @click="loadDataFromApiKey($event)"
              >Validate</md-button
            >
          </div>
          <div v-if="workspaces.length > 0">
            <h2>2. Select your workspace</h2>
            <multiselect
              v-model="selectedWorkspace"
              deselect-label="Can't remove this value"
              track-by="name"
              label="name"
              placeholder="Select one"
              :options="workspaces"
              :searchable="true"
              :allow-empty="false"
            >
              <template slot="singleLabel" slot-scope="{ option }"
                ><strong>{{ option.name }}</strong></template
              >
            </multiselect>
          </div>
          <div v-if="collections.length > 0">
            <h2>3. Select your collections</h2>
            <multiselect
              v-model="selectedCollections"
              deselect-label="Remove this value"
              track-by="name"
              label="name"
              placeholder="Select one"
              :options="collections"
              :searchable="true"
              :allow-empty="false"
              :multiple="true"
              :close-on-select="false"
            >
              <template slot="singleLabel" slot-scope="{ option }"
                ><strong>{{ option.name }}</strong></template
              >
            </multiselect>
          </div>
          <div v-if="envs.length > 0">
            <h2>4. Select your environment</h2>
            <multiselect
              v-model="selectedEnv"
              deselect-label="Can't remove this value"
              track-by="name"
              label="name"
              placeholder="Select one"
              :options="envs"
              :searchable="true"
              :allow-empty="false"
            >
              <template slot="singleLabel" slot-scope="{ option }"
                ><strong>{{ option.name }}</strong></template
              >
            </multiselect>
          </div>
          <div v-if="selectedEnv && selectedCollections.length > 0">
            <h2>5. Upload your global variables</h2>
            <input type="file" @change="readFile" />
          </div>
          <div v-if="selectedEnv && selectedCollections.length > 0">
            <h2>
              6. Get alerted by email<span
                ><md-icon>help</md-icon
                ><md-tooltip md-direction="right"
                  >Add your email to be notified when postman reports are
                  done</md-tooltip
                ></span
              >
            </h2>
            <md-field>
              <md-input
                v-model="email"
                type="text"
                name="email"
                autocomplete
              ></md-input>
            </md-field>
          </div>
          <br />
          <div v-if="selectedEnv && selectedCollections.length > 0">
            <md-button
              @click="generateReports"
              class="md-success md-lg"
              target="_blank"
            >
              <i class="fas fa-play"></i> Generate Reports
            </md-button>
          </div>
        </div>
      </div>
      <div
        class="section section-basic md-layout md-alignment-center-center"
        v-show="showSpinner"
      >
        <md-progress-spinner
          :md-diameter="100"
          :md-stroke="10"
          md-mode="indeterminate"
        ></md-progress-spinner>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  bodyClass: "index-page",
  props: {
    image: {
      type: String,
      default: require("@/assets/img/vue-mk-header.jpg")
    },
    leaf4: {
      type: String,
      default: require("@/assets/img/leaf4.png")
    },
    leaf3: {
      type: String,
      default: require("@/assets/img/leaf3.png")
    },
    leaf2: {
      type: String,
      default: require("@/assets/img/leaf2.png")
    },
    leaf1: {
      type: String,
      default: require("@/assets/img/leaf1.png")
    }
  },
  data() {
    return {
      email: null,
      password: null,
      apiKey: null,
      globalVars: null,
      envs: [],
      selectedEnv: null,
      collections: [],
      workspaces: [],
      selectedWorkspace: null,
      selectedCollections: [],
      leafShow: false,
      baseUrl: "https://2z0gwmeteh.execute-api.eu-west-1.amazonaws.com/newman",
      baseSupportBackendUrl: "https://wcc-recette.accor.net/ihm_api/newman",
      showSpinner: false
    };
  },
  methods: {
    readFile(ev) {
      const file = ev.target.files[0];
      const reader = new FileReader();
      reader.onload = e => {
        this.$data.globalVars = JSON.parse(e.target.result);
      };
      reader.readAsText(file);
    },
    leafActive() {
      if (window.innerWidth < 768) {
        this.leafShow = false;
      } else {
        this.leafShow = true;
      }
    },
    loadDataFromApiKey($event) {
      const headers = { "X-API-Key": this.$data.apiKey };
      this.$http
        .get(this.$data.baseSupportBackendUrl + "/workspaces", {
          headers
        })
        .then(result => {
          this.$data.workspaces = result.data.workspaces;
        });
    },
    generateReports() {
      this.$data.showSpinner = true;
      const body = {};
      body.apiKey = this.$data.apiKey;
      const workspace = {};
      workspace.name = this.$data.selectedWorkspace.name;
      body.workspace = workspace;
      const env = {};
      env.id = this.$data.selectedEnv.owner + "-" + this.$data.selectedEnv.id;
      env.name = this.$data.selectedEnv.name;
      body.env = env;
      const collections = [];
      for (let x in this.$data.selectedCollections) {
        const collectionName = this.$data.selectedCollections[x].name.replace(
          /\s/g,
          "_"
        );
        collections.push({
          id: this.$data.selectedCollections[x].uid,
          name: collectionName
        });
      }

      body.collections = collections;
      body.collection = collections[0];

      const globalVars = {};
      if (this.$data.globalVars) {
        globalVars.id = this.$data.globalVars.id;
        globalVars.name = this.$data.globalVars.name;
        const values = JSON.parse(JSON.stringify(this.$data.globalVars.values));
        globalVars.values = values;
      }
      body.globalVars = globalVars;

      const headers = { "Content-Type": "application/json" };

      localStorage.clear();
      localStorage.setItem(
        "selectedWorkspace",
        this.$data.selectedWorkspace.name
      );
      localStorage.setItem("selectedEnv", this.$data.selectedEnv.name);
      localStorage.setItem("email", this.$data.email);

      this.$http
        .post(this.$data.baseUrl + "/generate-reports", { headers, body })
        .then(result => {
          localStorage.setItem(
            "selectedCollections",
            JSON.stringify(result.data)
          );
          this.$router.push("collections-list");
        });
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.image})`,
        height: `500px`
      };
    },
    signupImage() {
      return {
        backgroundImage: `url(${this.signup})`
      };
    }
  },
  mounted() {
    this.leafActive();
    window.addEventListener("resize", this.leafActive);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.leafActive);
  },
  watch: {
    selectedWorkspace: function(val, oldVal) {
      if (val) {
        this.$data.selectedCollections = [];
        this.$data.selectedEnv = null;
        const headers = { "X-API-Key": this.$data.apiKey };
        let id = val.id;
        this.$http
          .get(`${this.$data.baseSupportBackendUrl}/collections?id=${id}`, {
            headers
          })
          .then(result => {
            this.$data.collections = result.data.collections;
            this.$http
              .get(
                `${this.$data.baseSupportBackendUrl}/environments?id=${id}`,
                {
                  headers
                }
              )
              .then(result => {
                this.$data.envs = result.data.environments;
              });
          });
      }
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

@media all and (min-width: 991px) {
  .btn-container-vue {
    display: flex;
  }
}
</style>
